import { useState, useEffect } from 'react';

interface CountdownTimerProps {
  startTime: number;
  duration: number; // seconds
}

function CountdownTimer({ startTime, duration }: CountdownTimerProps) {
  const [remaining, setRemaining] = useState(duration);

  useEffect(() => {
    const update = () => {
      const elapsed = (Date.now() - startTime) / 1000;
      const left = Math.max(0, duration - elapsed);
      setRemaining(Math.ceil(left));
    };

    update();
    const interval = setInterval(update, 250);
    return () => clearInterval(interval);
  }, [startTime, duration]);

  const pct = (remaining / duration) * 100;
  const isUrgent = remaining <= 10;

  return (
    <div className="flex items-center gap-2">
      <div
        className={`radial-progress text-sm ${
          isUrgent ? 'text-error' : 'text-primary'
        }`}
        style={
          {
            '--value': pct,
            '--size': '3rem',
            '--thickness': '3px',
          } as React.CSSProperties
        }
        role="progressbar"
      >
        <span className={`font-mono font-bold ${isUrgent ? 'animate-pulse' : ''}`}>
          {remaining}
        </span>
      </div>
    </div>
  );
}

export default CountdownTimer;
